/**
 * Airplanes Resource Page
 * Manage aircraft fleet
 */

import React, { useState } from 'react';
import { Typography, Button, Space, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {
  useResources,
  useToggleResourceAvailability,
} from '@/hooks/useCalendars';
import { ResourceTable } from '@/components/features/goldenwings/ResourceTable';
import type { Resource } from '@/api/types/calendars.types';

const { Title } = Typography;

export const AirplanesPage: React.FC = () => {
  const { t } = useTranslation();
  const { data: resources = [], isLoading } = useResources({
    resource_type: 'AIRPLANE',
  });
  const toggleAvailability = useToggleResourceAvailability();

  const handleEdit = (resource: Resource) => {
    message.info(`Edit airplane: ${resource.name}`);
    // TODO: Open edit modal
  };

  const handleDelete = (resource: Resource) => {
    message.info(`Delete airplane: ${resource.name}`);
    // TODO: Confirm and delete
  };

  const handleToggleAvailability = async (resource: Resource) => {
    try {
      await toggleAvailability.mutateAsync({
        resourceId: resource.id,
        data: {
          is_available: !resource.is_available,
          availability_notes: !resource.is_available
            ? 'Made available'
            : 'Made unavailable',
        },
      });
    } catch (error) {
      // Error handled by mutation
    }
  };

  const handleCreate = () => {
    message.info('Create new airplane');
    // TODO: Open create modal
  };

  return (
    <div style={{ padding: 24 }}>
      <Space
        direction="vertical"
        size="large"
        style={{ width: '100%', marginBottom: 24 }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Title level={2} style={{ margin: 0 }}>
            {t('goldenwings.airplanes')}
          </Title>
          <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
            Add Airplane
          </Button>
        </div>

        <ResourceTable
          resourceType="AIRPLANE"
          resources={resources}
          loading={isLoading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggleAvailability={handleToggleAvailability}
        />
      </Space>
    </div>
  );
};
